import { Switch as AntSwitch, SwitchProps } from "@basic-components";
import { useUserPermission } from "@/hooks/userPermission";

interface ISwitchProps extends SwitchProps {
  isView?: boolean;
  trueValue?: any;
  authKey?: string;
  options?: { label: string, value: any }[];
  onChange?: (value: any) => void;
}   
export const Switch = ({ isView, value, options,trueValue, authKey, ...rest }: ISwitchProps) => {

  const option = options?.find(item => item.value === value);
  const handleChange = (checked: boolean) => {
    if (checked) {
      rest.onChange?.(trueValue);
    } else {
      rest.onChange?.(options?.find(item => item.value !== trueValue)?.value);
    }
  };
  if (isView) return option?.label || '--';

  const hasPermission = useUserPermission(authKey);

  if (!hasPermission) {
    return option?.label || '--';
  }
  
  return <AntSwitch  {...rest} value={value === trueValue} onChange={handleChange} />;
};